import { GetterTree } from 'vuex';
import { MutationRequestStatus, RootState } from '../types';
import {
  ActivateOrderResponse, Basket, BasketInformations, CheckoutData, OrderState,
} from './types';
import { BaseMoney } from '../price/types';

export const getters: GetterTree<OrderState, RootState> = {
  basket: (state): Basket => state.basket?.data?.basket,
  basketInfo: (state): BasketInformations => state.basket?.data?.info,
  checkoutData: (state): CheckoutData => state.basket?.data,
  basketPrice: (state): BaseMoney => state.basket?.data?.price,
  basketBasePrice: (state): BaseMoney => state.basket?.data?.basePrice,
  basketDiscount: (state): number => state.basket?.data?.discount,

  basketLoading: (state): boolean => state.basket.status === MutationRequestStatus.LOADING,
  basketError: (state): boolean => state.basket.status === MutationRequestStatus.ERROR,
  basketLoaded: (state): boolean => state.basket.status === MutationRequestStatus.SUCCESS,

  activatedOrder: (state): ActivateOrderResponse => state.order.data,
  orderActivateError: (state): string => state.order?.error.message,
  orderActivationLoading: (state) => state.order.status === MutationRequestStatus.LOADING,
  orderActivationLoaded: (state) => state.order.status === MutationRequestStatus.SUCCESS,

  orderActivateLaterLoading: (state) => state.orderLater.status === MutationRequestStatus.LOADING,
  orderActivateLaterError: (state) => state.orderLater?.error.message,
};
